module.exports = __webpack_public_path__ + "img/orbit-card-pool-participations.0bf02c97.png";